import { getUserInfo, login, bindWeixinInfo, getAccountInfo } from '@/apis/user';
import { setToken, removeToken } from '@/utils/storage';

const user = {
  state: {
    info: {},
    hasLogin: false,
    isWeixin: false,
    accountInfo: {}
  },
  mutations: {
    SET_USER: (state, user) => {
      state.info = user;
    },
    SET_USER_LOGIN_STATUS: (state, status) => {
      state.hasLogin = status;
    },
    SET_ISWEIXIN_STATUS: (state, status) => {
      state.isWeixin = status;
    },
    SET_ACCONT: (state, account) => {
      state.accountInfo = account;
    }
  },
  actions: {
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then(result => {
            if (result.errorCode === '0') {
              commit('SET_USER', result.data);
              setToken(result.data.token);
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then(result => {
            if (result.errorCode === '0') {
              commit('SET_USER', result.data);
              setToken(result.data.token);
              commit('SET_USER_LOGIN_STATUS', true);
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    setIsWeixinGongzhonghao({ commit }, status) {
      commit('SET_ISWEIXIN_STATUS', status);
    },
    onBindWeixinInfo({ commit }, code) {
      return new Promise((resolve, reject) => {
        bindWeixinInfo(code)
          .then(result => {
            if (result.errorCode === '0') {
              resolve(result);
            }
          })
          .catch(err => {
            reject(err);
            throw err;
          });
      });
    },
    GetAccountInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getAccountInfo()
          .then(result => {
            if (result.errorCode === '0') {
              commit('SET_ACCONT', result.data);
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    setLoginStatus({ commit }, status) {
      commit('SET_USER_LOGIN_STATUS', status);
    },
    Logout({ commit }) {
      commit('SET_USER_LOGIN_STATUS', false);
      commit('SET_USER', {});
      removeToken();
    }
  }
};
export default user;
